import React from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import BreadCrumb from "components/common/BreadCrumb";
import { WorkOrdersTable } from "./WorkOrdersTable";
import { Link } from "react-router-dom";

import { getDocumentTitle } from "utils/helpers";
import { useAccess } from "features/Authentication/hooks/useAccess";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";

const WorkOrderList = () => {
  document.title = getDocumentTitle("Work Orders");
  const { can } = useAccess();

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Work Orders" pageTitle="Work Orders" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex justify-content-between">
                  <h5 className="card-title mb-0">Work Order List</h5>
                  {can(Permissions.WORK_ORDER.CREATE) ? (
                    <Link to="/work-orders/create" className="btn btn-primary">
                      <i className="ri-add-line align-bottom me-1"></i> Add Work
                      Order
                    </Link>
                  ) : null}
                </CardHeader>
                <CardBody>
                  <WorkOrdersTable />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default WorkOrderList;
